import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TranslateArticleResponse } from 'src/hooks/useTranslateArticle';

interface TranslateArticleState {
  isTranslated: boolean;
  selectedTargetLanguage: string;
  translateResult: TranslateArticleResponse;
  openPopupTranslate: boolean;
}

const initialState: TranslateArticleState = {
  isTranslated: false, // for tracking if currently showing translated text
  selectedTargetLanguage: 'english', //selected target language to translate
  translateResult: null,
  openPopupTranslate: false
};

const translateArticleSlice = createSlice({
  name: 'translateArticle',
  initialState,
  reducers: {
    setIsTranslated: (state, action: PayloadAction<boolean>) => {
      state.isTranslated = action.payload;
    },
    setResultTranslationData: (
      state,
      action: PayloadAction<TranslateArticleResponse>
    ) => {
      state.translateResult = action.payload;
    },
    setSelectedTargetLanguage: (state, action: PayloadAction<string>) => {
      state.selectedTargetLanguage = action.payload;
    },
    setOpenPopupTranslate: (state, action: PayloadAction<boolean>) => {
      state.openPopupTranslate = action.payload;
    },
    resetTranslation: (state) => {
      state.isTranslated = initialState.isTranslated;
      state.translateResult = initialState.translateResult;
      state.selectedTargetLanguage = initialState.selectedTargetLanguage;
      state.openPopupTranslate = initialState.openPopupTranslate;
    }
  }
});

export const {
  setIsTranslated,
  resetTranslation,
  setSelectedTargetLanguage,
  setResultTranslationData,
  setOpenPopupTranslate
} = translateArticleSlice.actions;

export default translateArticleSlice.reducer;
